import { render } from "./Q3DetailleeOptionA.vue?vue&type=template&id=2dfa8b6a"
import script from "./Q3DetailleeOptionA.vue?vue&type=script&lang=js"
export * from "./Q3DetailleeOptionA.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__